"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectBOPages_1 = __importDefault(require("./appStateSelectBOPages"));
const appStateSelectBOInitialPageId = (state) => {
    const pages = (0, appStateSelectBOPages_1.default)(state);
    if (!pages) {
        return undefined;
    }
    const initialPage = Object.values(pages)
        .find((page) => page && page.initialPage);
    return initialPage === null || initialPage === void 0 ? void 0 : initialPage.id;
};
exports.default = appStateSelectBOInitialPageId;
